import React, { useState, useRef, useEffect, useLayoutEffect, useCallback } from "react";

// eslint-disable-next-line import/order
import NavbarLinks from "./navbarLinks";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

import { getAuthorizationToken } from "@/auth/tokenStore";

// import useGetFirmLogo from "../FirmSettings/firm-branding/hooks/useGetFirmBranding";
import { closeSidebar, toggleSidebar } from "../../Redux/menu/actions";
import {
  searchGlobal,
  setSearchDocument,
  setSearchResult,
  setTabsResultCount,
} from "../../Redux/search/searchSlice";
import {
  setCurrentSearchStatus,
  setSearchText,
  setsearchAlphabet,
} from "../../Redux/search/searchSlice";
import { setBlurEffect } from "../../Redux/header_blur/action";
import "./Navbars.css";
import { useDocumentModal } from "../../../src/Components/common/CustomModal/CustomModalContext";
import { getCaseId, getClientId, mediaRoute } from "../../Utils/helper";
import { isEventForViewedClient } from "../../Utils/clientScopedEvent.mjs";
// import logo from "../../assets/logo/PClogo.svg";
// import smallLogo from "../../assets/logo/PClogosmall-2.svg";
import { useStatusWebSocket } from "../../Hooks/useStatusWebSocket";
import { addStatusToHeader, removeStatusFromHeader } from "../../Redux/header/headerDataSlice";

import NewNavbarProfile from "./NewNavbarProfile";
import DetailBar from "./detailBar";
// import { useCaseStatus } from "./useCaseStatus";

const NavBar = (props) => {
  const caseId = getCaseId();
  // const isAfterLogin = localStorage.getItem("isAfterLogin");
  // const { statuses } = useCaseStatus(caseId, isAfterLogin);
  const dispatch = useDispatch();
  const isSidebarOpen = useSelector((state) => state.menu.isOpen);
  const [formData, setFormData] = useState("");
  const blurEffect = useSelector((state) => state.blurEffect.blurEffect);
  const token = getAuthorizationToken();
  const searchRef = useRef(null);

  // WebSocket handler for real-time status updates
  const handleStatusWebSocketUpdate = useCallback(
    (message) => {
      if (message.type === "status_updated" && message.data) {
        const { status_id, is_triggered, client_id } = message.data;

        if (!isEventForViewedClient(client_id, getClientId())) return;

        if (is_triggered) {
          // Fetch the status details from stages_data or make a lightweight object
          // For now, we create a minimal status object - the backend should send full status data
          const statusData = message.data.status || { id: status_id, name: `Status ${status_id}` };
          dispatch(addStatusToHeader({ status_id, status: statusData }));
        } else {
          dispatch(removeStatusFromHeader({ status_id }));
        }
      }
    },
    [dispatch]
  );

  // Connect to WebSocket for status updates
  useStatusWebSocket(caseId, handleStatusWebSocketUpdate);

  // Logic for redirecting use to search page when click in the Search Form
  const navigate = useNavigate();
  const location = useLocation();
  const isSearchURL = location.pathname.includes("search");

  const headerData = useSelector((state) => state?.headerData.headerSummary);
  // const attorneyBranding = useSelector((state) => state.settings?.attorneyBranding?.logo);
  // const attorneyBranding = headerData?.attorney_branding_logo;
  const statuses = headerData?.status_data;

  document.addEventListener("click", function (event) {
    const target = event.target;
    const menuBtn = document.getElementById("leftBtn");

    if (!menuBtn?.contains(target)) {
      dispatch(closeSidebar());
    }
  });

  useEffect(() => {
    dispatch(setBlurEffect(false));
  }, [dispatch]);

  const bodyElement = document.querySelector("body");
  React.useEffect(() => {
    if (bodyElement && bodyElement.classList?.contains("modal-open")) {
      bodyElement.style.overflow = "hidden !important";
    } else {
      bodyElement.style.overflow = "auto  !important";
    }
  }, []);

  const handleChange = (e) => {
    const { value } = e.target;
    setFormData(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(setSearchText(formData));
    dispatch(searchGlobal({ name: formData, tab_name: "tabs", token: token }));
    dispatch(setCurrentSearchStatus("tabs"));
    dispatch(setsearchAlphabet(false));
    dispatch(setSearchResult({}));
    dispatch(
      setTabsResultCount({
        invoice: 0,
        incident: 0,
        "incident-date": 0,
        check: 0,
        "client-name": 0,
        "client-email": 0,
        "client-SSN": 0,
        "client-phone": 0,
        "client-birthday": 0,
        defendant: 0,
        "defendant-phone": 0,
        witness: 0,
        claim: 0,
        "court-case": 0,
        otherparty: 0,
        address: 0,
        notes: 0,
        document: 0,
      })
    );
  };

  useEffect(() => {
    if (searchRef.current) {
      searchRef.current.focus();
    }
  }, []);

  // For viewing document when redirect from searchPage
  const searchDocument = useSelector((state) => state.searchS.searchDocument);
  const { showDocumentModal } = useDocumentModal();
  useEffect(() => {
    if (searchDocument) {
      showDocumentModal("document", mediaRoute(searchDocument.upload), searchDocument);
      dispatch(setSearchDocument(""));
    }
  }, [searchDocument]);

  const [expanded, setExpanded] = useState(false);

  const handleExpand = () => {
    // Trigger the expansion when the input is clicked
    setExpanded(!expanded);
  };
  const [width, setWidth] = useState(0);
  const logoWidth = useRef(null);
  const _lastCalculatedSrc = useRef(null);
  const _hasCalculatedOnLoad = useRef(false);
  const [preferences, setPreferences] = useState(null);
  const [isTabletView, setisTabletView] = useState(window.innerWidth < 1080);
  const shouldBeCollapsed = preferences?.SidebarView === true ? true : false;
  useEffect(() => {
    const getUserPreferencesFromStorage = () => {
      const preferences = localStorage.getItem("userPreferences");
      const preferencesObj = preferences ? JSON.parse(preferences) : null;
      setPreferences(preferencesObj);
    };
    getUserPreferencesFromStorage();
  }, []);

  useEffect(() => {
    const handleResize = () => setisTabletView(window.innerWidth < 1081);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useLayoutEffect(() => {
    if (!logoWidth.current) return;

    const img = logoWidth.current;

    // Calculate immediately on mount before paint
    const initialWidth = img.getBoundingClientRect().width - 205;
    setWidth(initialWidth);

    const observer = new ResizeObserver((entries) => {
      const entry = entries[0];
      if (!entry) return;
      const width = entry.contentRect.width;
      const nextWidth = width - 205;
      setWidth((prev) => (prev === nextWidth ? prev : nextWidth));
    });

    observer.observe(img);

    return () => observer.disconnect();
  }, [logoWidth]);
  // const { data: getFirmLogo } = useGetFirmLogo();
  const { data: getFirmLogo } = useSelector((state) => state.firmLogo);
  return (
    <>
      <header
        className="header-main"
        style={{
          cursor: "pointer",
        }}
      >
        <div
          className={
            "logo Header-z-index-99999 default-branding-logo branding-logo-div header-logo-container-top"
          }
          style={
            blurEffect
              ? { filter: "blur(4px)", cursor: "pointer", left: "2px" }
              : { cursor: "pointer", left: "2px" }
          }
        >
          <div ref={logoWidth} className="logo-wrap">
            {/* <img
              className={"logoss"}
              ref={logoWidth}
              // onLoad={calculateLogoAreaWidth}
              style={{
                height: "70px",
                objectFit: "contain",
                paddingLeft: "2px",
                paddingTop: "5px",
                paddingRight: "0px",
                paddingBottom: "5px",
                minWidth: shouldBeCollapsed || isTabletView ? "91.5px" : "185px",
                maxWidth: shouldBeCollapsed || isTabletView ? "91.5px" : "185px",
                width: shouldBeCollapsed || isTabletView ? "91.5px" : "185px",
              }}
              src={
                shouldBeCollapsed || isTabletView
                  ? getFirmLogo?.collapsed_logo
                    ? getFirmLogo?.collapsed_logo
                    : ""
                  : getFirmLogo?.logo
                    ? getFirmLogo?.logo
                    : ""
              }
            /> */}
            {(
              shouldBeCollapsed || isTabletView ? getFirmLogo?.collapsed_logo : getFirmLogo?.logo
            ) ? (
              <img
                className={"logoss"}
                // ref={logoWidth}
                style={{
                  height: "70px",
                  objectFit: "contain",
                  paddingLeft: "2px",
                  paddingTop: "5px",
                  paddingRight: "0px",
                  paddingBottom: "5px",
                  minWidth: shouldBeCollapsed || isTabletView ? "91.5px" : "185px",
                  maxWidth: shouldBeCollapsed || isTabletView ? "91.5px" : "185px",
                  width: shouldBeCollapsed || isTabletView ? "91.5px" : "185px",
                }}
                src={
                  shouldBeCollapsed || isTabletView ? getFirmLogo.collapsed_logo : getFirmLogo.logo
                }
              />
            ) : (
              <div
                // ref={logoWidth}
                style={{
                  height: "70px",
                  minWidth: shouldBeCollapsed || isTabletView ? "91.5px" : "185px",
                  maxWidth: shouldBeCollapsed || isTabletView ? "91.5px" : "185px",
                  width: shouldBeCollapsed || isTabletView ? "91.5px" : "185px",
                  // transform: "skew(11.31deg, 0deg)",
                }}
              />
            )}
          </div>
        </div>
        <div
          className="d-flex d-flex-1 align-items-center"
          style={{
            cursor: "pointer",
          }}
        >
          {/* Navbar Profile */}
          <NewNavbarProfile />
          <div
            className="top-nav-wrapper d-flex d-flex-1"
            style={
              blurEffect
                ? { filter: "blur(4px)", cursor: "pointer" }
                : { transform: "translateY(0rem)", cursor: "pointer" }
            }
          >
            <NavbarLinks expanded={expanded} />
            <div
              className="search-icon-wrap"
              style={{
                cursor: "pointer",
              }}
            >
              <button
                className={"more-button"}
                // onClick={toggleTopNav}
              >
                <span className="ic ic-17 h-100 has-no-after text-white d-flex align-items-center justify-content-center rotate-180">
                  <svg
                    width={17}
                    height={50}
                    viewBox="0 0 17 50"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0 16H4.59998L8.5 19.95L12.4 16H17L8.5 24.55L0 16Z"
                      fill="currentColor"
                    />
                    <path
                      d="M0 25.4512H4.59998L8.5 29.4012L12.4 25.4512H17L8.5 34.0012L0 25.4512Z"
                      fill="currentColor"
                    />
                  </svg>
                </span>
              </button>
              <button id="searchIcon" className="search-icon ps-md-3 pe-md-3">
                <i className="ic ic-discovery ic-29" />
              </button>
              {isSearchURL ? (
                <form
                  className="search-form search-form-control-skew bg-white"
                  id="search-form"
                  style={{
                    position: "relative", // Stay in normal flow
                    marginRight: "0px",
                    width: expanded ? "216px" : "216px",
                    transition: expanded
                      ? "width 0.3s ease-out, margin-left 0.3s ease-out"
                      : "width 0.3s ease-in, margin-left 0.3s ease-in", // Add margin transition
                    marginLeft: expanded ? "0%" : "0%",
                  }}
                  onSubmit={handleSubmit}
                >
                  <input
                    type="text"
                    name="name"
                    ref={searchRef}
                    id="search_header"
                    className="form-control w-100 header-search-input"
                    defaultValue=""
                    onChange={handleChange}
                    onClick={handleExpand}
                    style={{
                      backgroundColor: "white",
                    }}
                  />
                  <div
                    className="search-btn search-btn-control-skew"
                    style={{ marginRight: "0px", right: "1px" }}
                  >
                    <input
                      className="btn H-btn"
                      type="submit"
                      form="search-form"
                      value="Search"
                      style={{ paddingLeft: "16px", paddingRight: "5.5px" }}
                    />
                  </div>
                  <div
                    className="right-skew header-right-transform-width8px"
                    style={{ height: "99%", right: "-7px" }}
                  />
                  {/* <div
                    className="left-skew Header-left-8px-width-8px"
                    style={{ height: "100%" }}
                  /> */}
                </form>
              ) : (
                <form
                  onClick={() => navigate("/search/")}
                  className="search-form search-form-control-skew"
                  id="search-form"
                  style={{
                    position: "relative",
                    marginRight: "0px",
                    width: expanded ? "216px" : "216px",
                    transition: expanded
                      ? "width 0.3s ease-out, margin-left 0.3s ease-out"
                      : "width 0.3s ease-in, margin-left 0.3s ease-in",
                    marginLeft: expanded ? "0%" : "0%",
                  }}
                >
                  <input
                    type="button"
                    name="name"
                    id="search_header"
                    className="form-control w-100"
                    defaultValue=""
                    onClick={handleExpand}
                  />
                  <div
                    className="search-btn search-btn-control-skew"
                    style={{ marginRight: "0px", right: "1px" }}
                  >
                    <input
                      className="btn H-btn"
                      type="submit"
                      form="search-form"
                      value="Search"
                      style={{ paddingLeft: "16px", paddingRight: "5.5px" }}
                    />
                    {/* <div className="right-skew header-right-transform-width-bg"></div>
                    <div
                      className="left-skew header-left-transform-width-bg-height"
                      style={{ height: "100%" }}
                    ></div> */}
                  </div>
                  <div
                    className="right-skew header-right-transform-width8px"
                    style={{ height: "99%", right: "-7px" }}
                  />
                  {/* <div
                    className="left-skew Header-left-8px-width-8px"
                    style={{ height: "100%" }}
                  /> */}
                </form>
              )}
            </div>
            {/* side bar button for small screens */}
            <div
              className="menu-btn"
              style={{
                cursor: "pointer",
              }}
            >
              <button
                id="leftBtn"
                className="btn d-flex align-items-center justify-content-center"
                onClick={() => dispatch(toggleSidebar())}
              >
                <div id="nav-icon3" className={isSidebarOpen ? "open" : ""}>
                  <span />
                  <span />
                  <span />
                  <span />
                </div>
              </button>
            </div>
          </div>
        </div>
      </header>
      <DetailBar
        flaggedPageName={props?.flaggedPageName || ""}
        newFlags={props?.newFlags}
        setNewFlags={props?.setNewFlags}
        statuses={statuses}
        width={width}
      />
    </>
  );
};

export default React.memo(NavBar);
